var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 14.998,
    viewBox: "0 0 15 14.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 15,
    height: 14.998,
    transform: "translate(0 0)",
    fill: "current"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M12.6,14.595,4.58,22.612a.833.833,0,0,1-.377.208L1,23.622a.791.791,0,0,1-.192.024.807.807,0,0,1-.569-.233.79.79,0,0,1-.208-.762l.8-3.207a.764.764,0,0,1,.208-.377l8.017-8.017a.807.807,0,0,1,1.138,0L12.6,13.457a.807.807,0,0,1,0,1.138",
    transform: "translate(0 -8.649)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M56.128,4.19l-2.8-2.8a.512.512,0,0,1,0-.724L53.852.15a.512.512,0,0,1,.724,0l2.8,2.8a.512.512,0,0,1,0,.724l-.521.521a.512.512,0,0,1-.724,0",
    transform: "translate(-42.522 0)",
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.11e0a7ee.svg";
export { ForwardRef as ReactComponent };